module.exports = __webpack_public_path__ + "static/frontendstumbles-teaser-5ad2cdb74ccc5a67f7201d7c60e80d4a.jpg";